import { render, staticRenderFns } from "./adminInspectionPlanList.vue?vue&type=template&id=83f4cc64&scoped=true"
import script from "./adminInspectionPlanList.vue?vue&type=script&lang=js"
export * from "./adminInspectionPlanList.vue?vue&type=script&lang=js"
import style0 from "./adminInspectionPlanList.vue?vue&type=style&index=0&id=83f4cc64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f4cc64",
  null
  
)

export default component.exports